import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rumi-hai',
  templateUrl: './rumi-hai.component.html',
  styleUrls: ['./rumi-hai.component.scss']
})
export class RumiHaiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
